import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

export const Container = styled(FlexRow)`
    width: max-content;
    flex-shrink: 0;
    align-items: center;
`;

export const Title = styled.div`
    ${setFontVariant("body2", colorsPalettes.carbon[400])};
    margin-right: 4px;
`;
